import MultiSelect from "../../components/MultiSelect";
import i18next from "i18next";
import * as gendersServices from "../../services/gendersServices";
import { useEffect, useState } from "react";
import useDebouncedFunction from "../../hooks/useDebouncedFunction";
import Autocomplete from "../../components/Autocomplete";

interface GendersSelectProps {
	options?: any;
	value?: any;
	showValue?: any;
	onChange?: any;
	error?: any;
	multiple?: boolean;
	categories?: number[];
	required?: boolean;
}

const GenderSelect = ({ multiple, value, showValue, onChange, error, categories, required }: GendersSelectProps) => {
	const [genders, setGenders] = useState<any>([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (!showValue) {
			handleChangeSearch({ target: { value: "" } });
		}
	}, [showValue, categories]);

	const handleChangeSearch = async (e: any) => {
		const value = e?.target?.value;

		setLoading(true);
		var genders = await gendersServices.search({ skip: 0, limit: 10, search: value, categories });
		genders = genders.result.map((gender) => ({
			label: gender.name,
			value: gender,
			...gender,
		}));
		setGenders(genders);
		setLoading(false);
	};

	const debouncedSearch = useDebouncedFunction(handleChangeSearch);

	if (multiple)
		return (
			<MultiSelect
				options={genders.filter((g) => !value.map((g) => g.id).includes(g.id))}
				placeholder={i18next.t("entity-search", { entity: i18next.t("Gender") })}
				datatestid={"search-gender-input"}
				label={i18next.t("genders")}
				value={value}
				onInputChange={(e) => {
					setLoading(true);
					debouncedSearch(e);
				}}
				renderValue={(value) => <div>{value.map(({ name }) => name).join(", ")}</div>}
				showValue={showValue}
				onChange={onChange}
				error={error}
				loading={loading}
				required={required}
			/>
		);

	return (
		<Autocomplete
			options={genders}
			placeholder={i18next.t("entity-search", { entity: i18next.t("Gender") })}
			datatestid={"search-gender-single-input"}
			label={i18next.t("genders")}
			value={value}
			onInputChange={(e) => {
				setLoading(true);
				debouncedSearch(e);
			}}
			required={required}
			showValue={showValue}
			onChange={onChange}
			error={error}
		/>
	);
};

export default GenderSelect;
